import { hasDataLayer } from './helpers'

/**
 * This redux middleware adds dispatched actions to the GTM data layer for analytics.
 * @type {import('redux').Middleware}
 * */
export const analyticsMiddleware = store => next => action => {
    if (hasDataLayer()) {
        const actionTrackingData = {
            type: action.type,
            payload: extractPayload(action),
        }

        window.dataLayer.push({
            action: actionTrackingData,
            event: 'action',
        })
    }

    return next(action)
}

function extractPayload(action) {
    switch (action.type) {
        // TODO on demand: Add data from payload based on action type
        // case ACTION_TYPE:
        //     return {
        //         foo: action.payload.foo,
        //     }
        default:
            return {}
    }
}
